var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNutritions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.226,
    height: 25.393,
    viewBox: "0 0 20.226 25.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(-2437.547 -342.442)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 3.89,
    cy: 3.89,
    r: 3.89,
    transform: "translate(2449.994 357.903)",
    fill: "#36a4ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 3.89,
    cy: 3.89,
    r: 3.89,
    transform: "translate(2437.547 350.124)",
    fill: "#36a4ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 2.153,
    cy: 2.153,
    r: 2.153,
    transform: "translate(2451.731 346.749)",
    fill: "#36a4ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 2.153,
    cy: 2.153,
    r: 2.153,
    transform: "translate(2441.649 342.442)",
    fill: "#36a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M2441.437,365.683l.212-12.136,12.235,8.246V348.9",
    fill: "none",
    stroke: "#36a4ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 2.153,
    cy: 2.153,
    r: 2.153,
    transform: "translate(2439.496 363.529)",
    fill: "#36a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M2441.649,353.547l5.441-2.066,6.794-2.579L2443.8,344.6Z",
    fill: "none",
    stroke: "#36a4ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_260",
    "data-name": "Line 260",
    y1: 3.89,
    x2: 12.235,
    transform: "translate(2441.649 361.793)",
    fill: "none",
    stroke: "#36a4ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutritions);
export default __webpack_public_path__ + "static/media/nutritions.3cb3724e89f4c051df1cc348baffda7f.svg";
export { ForwardRef as ReactComponent };